export { default } from './KnowledgeComponent';
